<app-logo-area [breadcrumbs]="[{'display': 'Content Platform', commands: ['/o', this.organization()?.id]}]"></app-logo-area>
<main>
  <app-headline-section [title]="'Storage Roots'"></app-headline-section>
  <section class="cl-section cl-section-regular cl-form">
    <div class="container">

      <div class="row">
        <div class="col-12">
          <table style="table-layout: fixed" class="cl-table-data">
            <colgroup>
            <col span="1" style="width: 40px">
            <col span="1" style="width: 100%">
            <col span="1" style="width: 170px">
          </colgroup>

          <thead>
            <tr>

              <th class="" style="margin-top: -4px; margin-bottom: -4px">
              </th>
              <th class="" style="margin-top: -4px; margin-bottom: -4px">
                Bucket Name
              </th>
              <th class="" style="margin-top: -4px; margin-bottom: -4px">
                Last Modified
              </th>

            </tr>
          </thead>
          @if (loading()) {
            <tbody>
              <tr class="cl-tr-no-data">
                <td colspan="100" style="text-align: center"> Loading Storage Roots ...<i class="fas fa-spinner fa-spin"></i></td>
              </tr>
            </tbody>
          } @else {
            <tbody>
              @if (roots().length === 0) {
                <tr class="cl-tr-no-data">
                  <td colspan="100" style="text-align: center">No data available.</td>
                </tr>
              }
              @for (it of roots(); track it) {
                <tr>
                  <td>
                    <div style="margin-top: -8px; margin-bottom: -12px;">
                      <i class="fas fa-hdd"></i>
                    </div>
                  </td>
                  <td>
                    <div style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">
                      <a [routerLink]="it | link"
                        (click)="$event.stopPropagation()">
                        {{ it.name | orgResolver }}
                      </a>
                    </div>
                  </td>
                  <td>
                    <div >
                      {{ it.last_modified | cldate }}
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }

        </table>
      </div>
    </div>


  </div>
</section>
</main>
